import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { CookieSetting } from "cookiesetting-component";
import { HelmetProvider } from "react-helmet-async";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import "./index.css";

const pathname = window.location.pathname.toLowerCase();

if (pathname === "/blog" || pathname === "/blog/") {
  const { protocol, host } = window.location;
  window.location.replace(`${protocol}//${host}/blog/home/`);
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <HelmetProvider>
      <Router
        basename={process.env.REACT_APP_BASENAME}
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <App />
        <div id="cookie-box">
          <CookieSetting
            privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK}
            configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
            analytics={process.env.REACT_APP_ANALYTICS_PATH}
          />
        </div>
      </Router>
    </HelmetProvider>
  </React.StrictMode>
);
